export default __webpack_public_path__ + "static/nr1_screenshot-full_Find-user-activity-data-in-Metrics-and-events-8c2c29ce6ce28dcb9af9d9aa6afd4612.webp";